import React, { Component } from 'react';

// A component that helps with rendering the articles for the site
class Article extends Component {
  render() {
    return (
      <div id="article-lining">
        {this.props.children}
        {this.props.asideArticle}
      </div>
    )
  }
}

export default Article;


// WEBPACK FOOTER //
// ./src/Article.js